module.exports = __webpack_public_path__ + "img/mainMenu-iconCart.17521d86.svg";